import React from "react";
import FILTVChannelCard from "./FILTVChannelCard";

export default function FILTVSidebar({ channels, activeLcn, onSelect, onMore }) {
    return (
        <div className="h-full max-h-[calc(100vh-160px)] overflow-y-auto bg-black/40 rounded-xl border border-zinc-800 p-2 space-y-2 scrollbar-hide">
            {channels.map((channel) => (
                <FILTVChannelCard
                    key={channel.lcn}
                    channel={channel}
                    active={channel.lcn === activeLcn}
                    onClick={() => onSelect(channel)}
                />
            ))}

            <button
                onClick={onMore}
                className="w-full rounded-xl p-3 border border-dashed border-zinc-700 text-zinc-300 hover:border-purple-400 hover:text-purple-300 transition-colors text-sm"
            >
                ➕ More Channels
            </button>
        </div>
    );
}
